import * as React from "react";
import { SVGProps } from "react";
export function BillDollarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.43 4.286H2.575C1.627 4.286.859 5.053.859 6v12c0 .947.768 1.714 1.715 1.714H21.43c.947 0 1.714-.767 1.714-1.714V6c0-.947-.767-1.714-1.714-1.714Z"
        stroke="#000"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.757 12.428a.429.429 0 1 1 0-.857M4.758 12.428a.429.429 0 1 0 0-.857M19.249 12.428a.428.428 0 1 1 0-.857M19.25 12.428a.429.429 0 1 0 0-.857M13.822 10.095a1.427 1.427 0 0 0-1.347-.952h-1.106a1.275 1.275 0 0 0-.273 2.52l1.684.369a1.43 1.43 0 0 1-.305 2.825h-.953a1.43 1.43 0 0 1-1.347-.952M12 9.143V7.714M12 16.285v-1.428"
        stroke="#000"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
